import { useState, useEffect } from "react";
// import { useNavigate } from "react-router-dom";
import axios from "axios";
import { BASE_URL } from "../config";
import OTPInput from "otp-input-react";
import "../styles/global.css";
import Form from "../containers/home/form";
import About from "../containers/home/about";
import Modal from "../components/Modal/Modal";
import Spinner from "../components/Spinner/Spinner";
import styles from "../styles/home.module.css";

const Home = ({ onNext }) => {

  const [businessName, setBusinessName] = useState("");
  const [ownerName, setOwnerName] = useState("");
  const [phone, setPhone] = useState("");

  const [email, setEmail] = useState("");
  const [address, setAddress] = useState("");
  const [latitude, setLatitude] = useState("");
  const [longitude, setLongitude] = useState("");
  // Referral code — optional. Pre-fill from URL `?ref=ABC123` so a
  // referrer can share a link like https://join.tor.digital/register?ref=TAL2025
  // and the new sign-up doesn't have to type anything.
  const [refCode, setRefCode] = useState(() => {
    if (typeof window === "undefined") return "";
    const url = new URL(window.location.href);
    return url.searchParams.get("ref") || "";
  });

  // If the user lands on /register without ?ref= but has a previously
  // stored code in localStorage (e.g. they bookmarked an attribution
  // link earlier), restore it so attribution survives sessions.
  useEffect(() => {
    if (refCode) {
      localStorage.setItem("refCode", refCode);
    } else {
      const stored = localStorage.getItem("refCode");
      if (stored) setRefCode(stored);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // Validate the referral code against the backend so we can show a
  // green banner ("🎁 X חודשי שימוש חינם זוהו") before the user
  // commits to filling out the form. Failure modes (not found,
  // expired, exhausted) silently drop back to the default 1-month
  // trial — the bonus is opt-in via the URL, not the registration UX.
  const [refCheck, setRefCheck] = useState(null); // { valid, freeMonths, description, reason }
  useEffect(() => {
    if (!refCode || !refCode.trim()) {
      setRefCheck(null);
      return;
    }
    let alive = true;
    axios
      .get(`${BASE_URL}/referral_codes/check/${encodeURIComponent(refCode.trim())}`)
      .then((r) => {
        if (alive) setRefCheck(r.data?.data || null);
      })
      .catch(() => {
        if (alive) setRefCheck(null);
      });
    return () => {
      alive = false;
    };
  }, [refCode]);

  // errors
  const [otpError, setOtpError] = useState("");
  const [wrongOtp, setWrongOtp] = useState("");

  const [isModalOpen, setIsModalOpen] = useState(false);

  const [OTP, setOTP] = useState("");
  const [loading2, setLoading2] = useState(false);

  // errors
  const [businessNameError, setBusinessNameError] = useState("");
  const [ownerNameError, setOwnerNameError] = useState("");
  const [phoneError, setPhoneError] = useState();
  const [emailError, setEmailError] = useState("");
  const [addressError, setAddressError] = useState("");

  const [alreadyRegistered, setAlreadyRegistered] = useState(false);
  const [emailExists, setEmailExists] = useState(false);
  const isValidPhoneNumber = (phoneNumber) => {
    const pattern = /^05\d{8}$/;
    return pattern.test(phoneNumber);
  };

  // const handlePhoneInputBlur = (e) => {
  //   const inputPhone = e.target.value;

  //   if (!isValidPhoneNumber(inputPhone)) {
  //     setPhoneError("יש להזין מספר תקין");
  //   } else {
  //     setPhoneError("");
  //   }
  // };

  const stepTwo = async (e) => {
    e.preventDefault();

    if (!OTP) {
      setOtpError("חובה לאמת את הטלפון הנייד");
    }

    if (OTP) {
      const payload = {
        phone,
        otp: OTP,
        // This site can show the signup chat (server A/B test decides)
        onboardingChatClient: "web",
      };

      setLoading2(true);

      // === VERIFY OTP ===
      try {
        let res = await axios.post(`${BASE_URL}/business/otp_verify`, payload);

        if (res.status === 201) {
          localStorage.setItem("business_id", res.data.user.id);
          localStorage.setItem("auth_token", res.data.token.access.token);
          localStorage.setItem("business_code", res.data.user.businessId);
          // Signup A/B group: "chat" replaces the setup steps with the chat
          sessionStorage.setItem("signup_variant", res.data.onboardingChat ? "chat" : "form");
          if (res.data.user.type !== undefined && res.data.user.type !== null) {
            localStorage.setItem("user_type", String(res.data.user.type));
          }

          // if its first time then update profile
          if (!res.data.user.first_time) {
            // === UPDATE BUSINESS PROFILE ===
            // Address is optional. If empty, default to "ישראל" so
            // the business doc still has a sensible value (the field
            // is shown publicly on the customer page, and "ישראל"
            // beats blank). Lat/lng are simply omitted in that case.
            const finalAddress = (address && address.trim()) || "ישראל";
            const payload = {
              id: res.data.user.id,
              // Email is optional; the API rejects an empty string
              ...(email && email.trim() ? { email: email.trim() } : {}),
              address: finalAddress,
              ...(latitude ? { latitude } : {}),
              ...(longitude ? { longitude } : {}),
              business_name: businessName,
              name: ownerName,
              phone,
              // Referral code — only sent if the user actually entered
              // one (or arrived via ?ref=). The Backend's updateBusiness
              // validation already accepts `refCode` as optional.
              ...(refCode && refCode.trim() ? { refCode: refCode.trim() } : {}),
              first_time: true,
            };

            let config = {
              headers: {
                Authorization: res.data.token.access.token,
              },
            };

            try {
              let updateRes = await axios.put(
                `${BASE_URL}/business/update_profile_info`,
                payload,
                config
              );
              console.log(updateRes, "heheheh");
              if (updateRes.status === 200) {
                localStorage.setItem("ownerName", ownerName);
                setIsModalOpen(false);
                // Navigate to business type selection after registration
                setTimeout(() => onNext(), 100);
              }
            } catch (error) {
              if (error.response.data.message === "Email already taken") {
                setIsModalOpen(false);
                setEmailExists(true);
              }
            }
          }
          // if not first time then show already registered modal
          else {
            setIsModalOpen(false);
            setAlreadyRegistered(true);
          }
        }
      } catch (error) {
        console.log(error);
        setWrongOtp("קוד אימות שגוי, נסו שוב");
      }

      setLoading2(false);
    }
  };

  return (
    <div className={styles.container}>
      <div className={styles.wrapper}>
        <div className={styles.card}>
          {refCheck?.valid && (
            <div
              dir="rtl"
              style={{
                background:
                  "linear-gradient(135deg, #DCFCE7 0%, #BBF7D0 100%)",
                border: "1.5px solid #4ADE80",
                borderRadius: 16,
                padding: "14px 18px",
                marginBottom: 16,
                color: "#14532D",
                fontSize: 14,
                fontWeight: 600,
                lineHeight: 1.5,
                textAlign: "right",
              }}
            >
              <div style={{ fontSize: 18, fontWeight: 900, marginBottom: 4 }}>
                🎁 קוד הטבה זוהה
              </div>
              <div>
                בסיום ההרשמה תקבלו <strong>{refCheck.freeMonths} חודשי שימוש חינם</strong>
                {refCheck.description ? ` · ${refCheck.description}` : ""}
              </div>
            </div>
          )}
          <Form
            setIsModalOpen={setIsModalOpen}
            businessName={businessName}
            setBusinessName={setBusinessName}
            ownerName={ownerName}
            setOwnerName={setOwnerName}
            phone={phone}
            setPhone={setPhone}
            email={email}
            setEmail={setEmail}
            address={address}
            setAddress={setAddress}
            refCode={refCode}
            setRefCode={setRefCode}
            businessNameError={businessNameError}
            setBusinessNameError={setBusinessNameError}
            ownerNameError={ownerNameError}
            setOwnerNameError={setOwnerNameError}
            phoneError={phoneError}
            setPhoneError={setPhoneError}
            emailError={emailError}
            setEmailError={setEmailError}
            addressError={addressError}
            setAddressError={setAddressError}
            setLatitude={setLatitude}
            setLongitude={setLongitude}
          />
          <About />
        </div>
      </div>

      {isModalOpen && (
        <div className={styles.sheetBackdrop}>
          <div className={styles.sheet}>
            <button className={styles.sheetClose} onClick={() => setIsModalOpen(false)}>✕</button>

            <div className={styles.sheetContent}>
              <div className={styles.sheetIcon}>📲</div>
              <h3 className={styles.sheetTitle}>קוד אימות נשלח!</h3>
              <p className={styles.sheetSubtitle}>
                שלחנו קוד אימות ב-WhatsApp למספר
              </p>
              <p className={styles.sheetPhone}>
                {phone?.replace(/(\d{3})(\d{3})(\d{4})/, '$1-$2-$3')}
              </p>
              <p className={styles.sheetHint}>הזינו את הקוד שקיבלתם</p>

              <div className={styles.otpContainer}>
                <OTPInput
                  value={OTP}
                  onChange={setOTP}
                  autoFocus
                  OTPLength={4}
                  otpType="number"
                  disabled={false}
                  style={{ justifyContent: "center", direction: "ltr" }}
                  inputStyles={{
                    marginRight: "0px",
                    margin: "0px 8px",
                    width: "46px",
                    height: "52px",
                    fontSize: "22px",
                    borderRadius: "12px",
                    border: "1.5px solid #e5e5ea",
                    background: "#f9f9fb",
                    textAlign: "center",
                  }}
                />
                {otpError && <span className={styles.errorMsg}>{otpError}</span>}
                {wrongOtp && <span className={styles.errorMsg}>{wrongOtp}</span>}
              </div>

              <button className={styles.sheetBtn} onClick={stepTwo}>
                {loading2 ? <Spinner /> : "אימות והרשמה"}
              </button>

              <p className={styles.sheetResend}>
                לא קיבלתי?{" "}
                <span onClick={() => {
                  setOTP("");
                  setWrongOtp("");
                  setIsModalOpen(false);
                  setTimeout(() => document.querySelector("form button")?.click(), 300);
                }}>שלח קוד בוואטסאפ</span>
              </p>
            </div>
          </div>
        </div>
      )}

      {alreadyRegistered && (
        <Modal>
          <div className={styles.already}>
            <span
              className={styles.error}
              onClick={() => window.location.reload()}
            >
              X
            </span>

            <p>נראה שמספר זה כבר קיים, הורידו את האפליקציה והתחברו למערכת</p>

            <div className={styles.store}>
              <a
                id="appclick"
                href="https://apps.apple.com/il/app/%D7%AA%D7%95%D7%A8-%D7%93%D7%99%D7%92%D7%99%D7%98%D7%9C-%D7%A0%D7%99%D7%94%D7%95%D7%9C-%D7%99%D7%95%D7%9E%D7%9F/id1602074493"
                target="_blank"
              >
                <img
                  src="/assets/appledown.svg"
                  alt="זמין להורדה ב-App Store"
                />
              </a>

              <a
                id="gclick"
                href=" https://play.google.com/store/apps/details?id=com.adminappointmentapp"
                target="_blank"
              >
                <img
                  src="/assets/googledown.svg"
                  alt="זמין להורדה ב-Google Play"
                />
              </a>
            </div>
          </div>
        </Modal>
      )}

      {emailExists && (
        <Modal>
          <div className={styles.already}>
            <span
              className={styles.error}
              style={{ cursor: "pointer" }}
              onClick={() => window.location.reload()}
            >
              X
            </span>

            <p>כתובת המייל כבר שימוש</p>

            <div className={styles.store}>
              <a
                id="appclick"
                href="https://apps.apple.com/il/app/%D7%AA%D7%95%D7%A8-%D7%93%D7%99%D7%92%D7%99%D7%98%D7%9C-%D7%A0%D7%99%D7%94%D7%95%D7%9C-%D7%99%D7%95%D7%9E%D7%9F/id1602074493"
                target="_blank"
              >
                <img
                  src="/assets/appledown.svg"
                  alt="זמין להורדה ב-App Store"
                />
              </a>

              <a
                id="gclick"
                href=" https://play.google.com/store/apps/details?id=com.adminappointmentapp"
                target="_blank"
              >
                <img
                  src="/assets/googledown.svg"
                  alt="זמין להורדה ב-Google Play"
                />
              </a>
            </div>
          </div>
        </Modal>
      )}
    </div>
  );
};

export default Home;
